import { render, staticRenderFns } from "./Projection.vue?vue&type=template&id=5ed0189f&scoped=true&"
import script from "./Projection.vue?vue&type=script&lang=js&"
export * from "./Projection.vue?vue&type=script&lang=js&"
import style0 from "./Projection.vue?vue&type=style&index=0&id=5ed0189f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed0189f",
  null
  
)

export default component.exports